<template>
    <Layout is-crm content-class="content--narrow">
        <div class="notifications">
            <h1 v-t="'crm.notifications.page.title'" />

            <NotificationsIterator group-by-date>
                <template #default="{ loading, groupedItems, pagination, noData }">
                    <div class="notifications__content">
                        <Spinner v-if="loading" />
                        <template v-if="noData">
                            <p v-t="'crm.notifications.noData'" class="notifications__nodata" />
                        </template>
                        <template v-else>
                            <NotificationsGroup
                                v-for="(items, name, i) in groupedItems"
                                :key="i"
                                :title="name"
                                :items="items"
                                class="notifications__group"
                            >
                                <template #item="{ item }">
                                    <NotificationsItem :item="item" />
                                </template>
                            </NotificationsGroup>
                            <footer>
                                <button
                                    v-if="pagination.hasNext"
                                    @click.prevent="pagination.next"
                                    v-text="$t('misc.loadmore')"
                                />
                            </footer>
                        </template>
                    </div>
                </template>
            </NotificationsIterator>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { NotificationsIterator, NotificationsGroup, NotificationsItem } from '../../components';

export default {
    name: 'NotificationsPage',
    components: {
        Layout,
        Spinner,
        NotificationsIterator,
        NotificationsGroup,
        NotificationsItem,
    },
};
</script>

<style lang="scss" src="./NotificationsPage.scss"></style>
